/* eslint-disable jira/filename-case */
import { useTenantContext } from '../tenant-context/index.tsx';

type CloudId = string;

/**
 * Returns the cloud ID for the current tenant.
 *
 * @agent-skills: tenant-context
 */
export const useCloudId = (): CloudId => {
	const tenantContext = useTenantContext();
	return tenantContext && tenantContext.cloudId;
};
